import { Action } from '@ngrx/store';
import { ErrorResponse, Product } from '~shared/models';

export enum BestSellingProductsActionTypes {
  LOAD_BEST_SELLING_PRODUCTS = '[custom-hub] Best selling products load',
  LOAD_BEST_SELLING_PRODUCTS_SUCCESS = '[custom-hub] Best selling products load success',
  LOAD_BEST_SELLING_PRODUCTS_FAILURE = '[custom-hub] Best selling products load failure',
}

export class LoadBestSellingProducts implements Action {
  readonly type = BestSellingProductsActionTypes.LOAD_BEST_SELLING_PRODUCTS;

  constructor(public payload: { categorySlugs: string[] }) {
  }
}

export class LoadBestSellingProductsSuccess implements Action {
  readonly type = BestSellingProductsActionTypes.LOAD_BEST_SELLING_PRODUCTS_SUCCESS;

  constructor(public payload: { products: Product[] }) {
  }
}

export class LoadBestSellingProductsFailure implements Action {
  readonly type = BestSellingProductsActionTypes.LOAD_BEST_SELLING_PRODUCTS_FAILURE;

  constructor(public payload: { error: ErrorResponse }) {
  }
}

export type BestSellingProductsActionsUnion = LoadBestSellingProducts
  | LoadBestSellingProductsSuccess
  | LoadBestSellingProductsFailure;
